import { useTranslation } from 'hooks';
import { Icon } from 'shared/ui/icon/icon';
import { ICONS } from 'shared/constants/images';
import { Skeleton } from 'shared/ui/skeleton/skeleton';
import { RunStatusChip } from 'shared/ui/run-status-chip/run-status-chip';
import { RunBlockStatus } from 'shared/hooks/useReportProgress';
import cls from './improvement-section-header.module.scss';

interface RuleStat {
  total: number;
  pass: number;
  needFix: number;
}

interface ImprovementSectionHeaderProps {
  title: string;
  stats?: RuleStat;
  isLoading?: boolean;
  isTrialExpired?: boolean;
  showOnlyTotal?: boolean;
  totalOverride?: number;
  runStatus?: RunBlockStatus | null;
}

export const ImprovementSectionHeader: React.FC<
  ImprovementSectionHeaderProps
> = ({
  title,
  stats,
  isLoading = false,
  isTrialExpired = false,
  showOnlyTotal = false,
  totalOverride,
  runStatus = null,
}) => {
  const { t } = useTranslation();
  const renderStats = () => {
    if (runStatus !== null) {
      if (runStatus !== 'ready') {
        return null;
      }
    } else if (isLoading) {
      return <Skeleton width={200} height={20} />;
    }

    if (!stats) {
      return null;
    }

    if (isTrialExpired) {
      return (
        <p className={cls.rulesStat}>
          <Icon pathToIcon={ICONS.lockGray} size={12} /> {t('rulesTotal')} •{' '}
          <Icon pathToIcon={ICONS.lockGray} size={12} /> {t('pass')} •{' '}
          <Icon pathToIcon={ICONS.lockGray} size={12} /> {t('needFix')}
        </p>
      );
    }

    if (showOnlyTotal) {
      return (
        <p className={cls.rulesStat}>
          {totalOverride ?? stats.total} {t('rulesTotal')}
        </p>
      );
    }

    return (
      <p className={cls.rulesStat}>
        {stats.total} {t('rulesTotal')} • {stats.pass} {t('pass')} •{' '}
        {stats.needFix} {t('needFix')}
      </p>
    );
  };

  return (
    <div className={cls.header}>
      <div className={cls.titleLine}>
        {runStatus !== null && <RunStatusChip status={runStatus} />}
        <h3 className={cls.sectionTitle}>{title}</h3>
      </div>
      {renderStats()}
    </div>
  );
};
